import { FunctionOpenInNewTab, Page } from "radium-omnibus";
import { FunctionGetPathUrl } from "../../../utils/useFunction";
import { useIsMobile } from "../../../utils/useIsMobile";
import React from "react";
import { useWindowSize } from "../../../utils/useWindowSize";

import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ContextLanguage } from "../../../context/Context.Language";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export const ID_OF_BANNER = "6310609e3c31c005713e62ba";

export const STYLE_BANNER =
  " h-full   w-[91%]  md:w-[1150px] cursor-pointer object-contain flex justify-center mx-auto rounded-2xl ";

const onClick = (banner, count, navigate, isMobile) => {
  // console.log("banner", { banner, count, navigate, isMobile });
  if (isMobile) {
    if (banner[`link_image_m_${count}`] === "MY_WASH") {
      // HomeClickToProgram(navigate, "My Wash", "6310a054f095c39af2b7503e");
      navigate("/MyWash");
    } else if (banner[`link_image_m_${count}`] === "MY_IRON") {
      // HomeClickToProgram(navigate, "My Iron", "6310a3cff095c39af2b75041");
      navigate("/MyIron");
    } else if (banner[`link_image_m_${count}`] === "MY_SHOES") {
      // HomeClickToProgram(navigate, "My Shoes", "6310a3d1f095c39af2b75045");
      navigate("/MyShoes");
    } else if (
      banner[`link_image_m_${count}`].includes("mylaundrythai") ||
      banner[`link_image_m_${count}`].includes("localhost")
    ) {
      const path = String(banner[`link_image_m_${count}`]).split("/");
      navigate(`/${path[path.length - 1]}`);
    } else if (banner[`link_image_m_${count}`]?.length > 0) {
      FunctionOpenInNewTab(banner[`link_image_m_${count}`]);
    } else {
      return;
    }
  } else {
    if (banner[`link_image_d_${count}`] === "MY_WASH") {
      // HomeClickToProgram(navigate, "My Wash", "6310a054f095c39af2b7503e");
      navigate("/MyWash");
    } else if (banner[`link_image_d_${count}`] === "MY_IRON") {
      // HomeClickToProgram(navigate, "My Iron", "6310a3cff095c39af2b75041");
      navigate("/MyIron");
    } else if (banner[`link_image_d_${count}`] === "MY_SHOES") {
      // HomeClickToProgram(navigate, "My Shoes", "6310a3d1f095c39af2b75045");
      navigate("/MyShoes");
    } else if (
      banner[`link_image_d_${count}`].includes("mylaundrythai") ||
      banner[`link_image_d_${count}`].includes("localhost")
    ) {
      const path = String(banner[`link_image_d_${count}`]).split("/");
      navigate(`/${path[path.length - 1]}`);
    } else if (banner[`link_image_d_${count}`]?.length > 0) {
      FunctionOpenInNewTab(banner[`link_image_d_${count}`]);
    } else {
      return;
    }
  }
};

const onClickTH = (banner, count, navigate, isMobile) => {
  if (isMobile) {
    if (banner[`link_image_m_${count}_th`] === "MY_WASH") {
      // HomeClickToProgram(navigate, "My Wash", "6310a054f095c39af2b7503e");
      navigate("/MyWash");
    } else if (banner[`link_image_m_${count}_th`] === "MY_IRON") {
      // HomeClickToProgram(navigate, "My Iron", "6310a3cff095c39af2b75041");
      navigate("/MyIron");
    } else if (banner[`link_image_m_${count}_th`] === "MY_SHOES") {
      // HomeClickToProgram(navigate, "My Shoes", "6310a3d1f095c39af2b75045");
      navigate("/MyShoes");
    } else if (
      banner[`link_image_m_${count}_th`].includes("mylaundrythai") ||
      banner[`link_image_m_${count}_th`].includes("localhost")
    ) {
      const path = String(banner[`link_image_m_${count}_th`]).split("/");
      navigate(`/${path[path.length - 1]}`);
    } else if (banner[`link_image_m_${count}_th`]?.length > 0) {
      FunctionOpenInNewTab(banner[`link_image_m_${count}_th`]);
    } else {
      return;
    }
  } else {
    if (banner[`link_image_d_${count}_th`] === "MY_WASH") {
      // HomeClickToProgram(navigate, "My Wash", "6310a054f095c39af2b7503e");
      navigate("/MyWash");
    } else if (banner[`link_image_d_${count}_th`] === "MY_IRON") {
      // HomeClickToProgram(navigate, "My Iron", "6310a3cff095c39af2b75041");
      navigate("/MyIron");
    } else if (banner[`link_image_d_${count}_th`] === "MY_SHOES") {
      // HomeClickToProgram(navigate, "My Shoes", "6310a3d1f095c39af2b75045");
      navigate("/MyShoes");
    } else if (
      banner[`link_image_d_${count}_th`].includes("mylaundrythai") ||
      banner[`link_image_d_${count}_th`].includes("localhost")
    ) {
      const path = String(banner[`link_image_d_${count}_th`]).split("/");
      navigate(`/${path[path.length - 1]}`);
    } else if (banner[`link_image_d_${count}_th`]?.length > 0) {
      FunctionOpenInNewTab(banner[`link_image_d_${count}_th`]);
    } else {
      return;
    }
  }
};

const RenderHomeBanner = ({ banner }) => {
  const size = useWindowSize();
  const isMobile = false;
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);

  const [count, setCount] = React.useState(1);
  const [isCounting, setIsCounting] = React.useState(true);

  let image_count_desktop_en = 0;
  let image_count_mobile_en = 0;

  let image_count_desktop_th = 0;
  let image_count_mobile_th = 0;

  if (
    banner?.key_image_d_1 !== "" &&
    banner?.key_image_d_1 !== null &&
    banner?.key_image_d_1 !== undefined
  ) {
    image_count_desktop_en++;
  }
  if (
    banner?.key_image_d_2 !== "" &&
    banner?.key_image_d_2 !== null &&
    banner?.key_image_d_2 !== undefined
  ) {
    image_count_desktop_en++;
  }
  if (
    banner?.key_image_d_3 !== "" &&
    banner?.key_image_d_3 !== null &&
    banner?.key_image_d_3 !== undefined
  ) {
    image_count_desktop_en++;
  }

  if (
    banner?.key_image_m_1 !== "" &&
    banner?.key_image_m_1 !== null &&
    banner?.key_image_m_1 !== undefined
  ) {
    image_count_mobile_en++;
  }
  if (
    banner?.key_image_m_2 !== "" &&
    banner?.key_image_m_2 !== null &&
    banner?.key_image_m_2 !== undefined
  ) {
    image_count_mobile_en++;
  }
  if (
    banner?.key_image_m_3 !== "" &&
    banner?.key_image_m_3 !== null &&
    banner?.key_image_m_3 !== undefined
  ) {
    image_count_mobile_en++;
  }
  //

  if (
    banner?.key_image_d_1_th !== "" &&
    banner?.key_image_d_1_th !== null &&
    banner?.key_image_d_1_th !== undefined
  ) {
    image_count_desktop_th++;
  }
  if (
    banner?.key_image_d_2_th !== "" &&
    banner?.key_image_d_2_th !== null &&
    banner?.key_image_d_2_th !== undefined
  ) {
    image_count_desktop_th++;
  }
  if (
    banner?.key_image_d_3_th !== "" &&
    banner?.key_image_d_3_th !== null &&
    banner?.key_image_d_3_th !== undefined
  ) {
    image_count_desktop_th++;
  }

  if (
    banner?.key_image_m_1_th !== "" &&
    banner?.key_image_m_1_th !== null &&
    banner?.key_image_m_1_th !== undefined
  ) {
    image_count_mobile_th++;
  }
  if (
    banner?.key_image_m_2_th !== "" &&
    banner?.key_image_m_2_th !== null &&
    banner?.key_image_m_2_th !== undefined
  ) {
    image_count_mobile_th++;
  }
  if (
    banner?.key_image_m_3_th !== "" &&
    banner?.key_image_m_3_th !== null &&
    banner?.key_image_m_3_th !== undefined
  ) {
    image_count_mobile_th++;
  }

  // React.useEffect(() => {
  //   let thisF = () => {
  //     if (!isMobile && language === "EN") {
  //       if (image_count_desktop_en > 1) {
  //         if (count >= image_count_desktop_en) {
  //           setTimeout(() => {
  //             setCount(1);
  //           }, 5000);
  //         } else {
  //           setTimeout(() => {
  //             setCount(count + 1);
  //           }, 5000);
  //         }
  //       }
  //     } else if (!isMobile && language === "TH") {
  //       if (image_count_desktop_th > 1) {
  //         if (count >= image_count_desktop_th) {
  //           setTimeout(() => {
  //             setCount(1);
  //           }, 5000);
  //         } else {
  //           setTimeout(() => {
  //             setCount(count + 1);
  //           }, 5000);
  //         }
  //       }
  //     }
  //   };

  //   thisF();

  //   return () => {
  //     thisF = () => {};
  //   };
  // }, [
  //   count,
  //   image_count_desktop_en,
  //   image_count_desktop_th,
  //   image_count_mobile_en,
  //   image_count_mobile_th,
  //   size,
  //   language,
  //   isMobile,
  // ]);

  React.useEffect(() => {
    let timeoutId;

    const incrementCount = () => {
      setCount((prevCount) =>
        prevCount >=
        (language === "TH" ? image_count_desktop_th : image_count_desktop_en)
          ? 1
          : prevCount + 1
      );

      timeoutId = setTimeout(incrementCount, 5000);
    };

    if (
      !isMobile &&
      language === "EN" &&
      isCounting &&
      image_count_desktop_en > 1
    ) {
      timeoutId = setTimeout(incrementCount, 5000);
    }

    if (
      !isMobile &&
      language === "TH" &&
      isCounting &&
      image_count_desktop_th > 1
    ) {
      timeoutId = setTimeout(incrementCount, 5000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    count,
    image_count_desktop_en,
    language,
    isMobile,
    isCounting,
    image_count_desktop_th,
  ]);

  // console.log("BANNER :", {
  //   count,
  //   image_count_desktop_en,
  //   language,
  //   isMobile,
  //   isCounting,
  //   image_count_desktop_th,
  // });

  React.useEffect(() => {
    setCount(1);
  }, [language, isMobile]);

  // Event handlers for onMouseEnter and onMouseOut
  const handleMouseEnter = () => {
    setIsCounting(false); // Stop the count
  };

  const handleMouseOut = () => {
    setIsCounting(true); // Continue the count
  };

  const isThai = language === "TH";

  if (banner?.status === "Banner") {
    return (
      <div className=" w-full mt-[80px]  md:mt-[72px]  ">
        <img
          onMouseEnter={() => {
            handleMouseEnter();
          }}
          onMouseOut={() => {
            handleMouseOut();
          }}
          onClick={() => {
            if (isThai) {
              onClickTH(banner, count, navigate, isMobile);
            } else {
              onClick(banner, count, navigate, isMobile);
            }
          }}
          loading="lazy"
          src={
            isThai
              ? isMobile
                ? FunctionGetPathUrl(banner[`key_image_m_${count}_th`])
                : FunctionGetPathUrl(banner[`key_image_d_${count}_th`])
              : isMobile
              ? FunctionGetPathUrl(banner[`key_image_m_${count}`])
              : FunctionGetPathUrl(banner[`key_image_d_${count}`])
          }
          className={STYLE_BANNER}
        />

        {/* <LazyLoadImage
          onMouseEnter={() => {
            handleMouseEnter();
          }}
          onMouseOut={() => {
            handleMouseOut();
          }}
          onClick={() => {
            if (isThai) {
              onClickTH(banner, count, navigate, isMobile);
            } else {
              onClick(banner, count, navigate, isMobile);
            }
          }}
          src={
            isThai
              ? isMobile
                ? FunctionGetPathUrl(banner[`key_image_m_${count}_th`])
                : FunctionGetPathUrl(banner[`key_image_d_${count}_th`])
              : isMobile
              ? FunctionGetPathUrl(banner[`key_image_m_${count}`])
              : FunctionGetPathUrl(banner[`key_image_d_${count}`])
          }
          className={STYLE_BANNER}
        /> */}
      </div>
    );
  } else if (banner?.status === "Video") {
    return (
      <div className=" px-4 md:px-0 w-full">
        <video className={STYLE_BANNER} autoPlay muted loop playsInline>
          <source src={banner?.link} type="video/mp4" />
        </video>
      </div>
    );
  } else if (banner?.status !== "") {
    return "";
  } else {
    return <React.Fragment />;
  }
};

const RenderHomeBannerMobile = ({ banner }) => {
  const size = useWindowSize();
  const isMobile = true;
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);

  const [count, setCount] = React.useState(1);

  let image_count_desktop_en = 0;
  let image_count_mobile_en = 0;

  let image_count_desktop_th = 0;
  let image_count_mobile_th = 0;

  if (
    banner?.key_image_d_1 !== "" &&
    banner?.key_image_d_1 !== null &&
    banner?.key_image_d_1 !== undefined
  ) {
    image_count_desktop_en++;
  }
  if (
    banner?.key_image_d_2 !== "" &&
    banner?.key_image_d_2 !== null &&
    banner?.key_image_d_2 !== undefined
  ) {
    image_count_desktop_en++;
  }
  if (
    banner?.key_image_d_3 !== "" &&
    banner?.key_image_d_3 !== null &&
    banner?.key_image_d_3 !== undefined
  ) {
    image_count_desktop_en++;
  }

  if (
    banner?.key_image_m_1 !== "" &&
    banner?.key_image_m_1 !== null &&
    banner?.key_image_m_1 !== undefined
  ) {
    image_count_mobile_en++;
  }
  if (
    banner?.key_image_m_2 !== "" &&
    banner?.key_image_m_2 !== null &&
    banner?.key_image_m_2 !== undefined
  ) {
    image_count_mobile_en++;
  }
  if (
    banner?.key_image_m_3 !== "" &&
    banner?.key_image_m_3 !== null &&
    banner?.key_image_m_3 !== undefined
  ) {
    image_count_mobile_en++;
  }
  //

  if (
    banner?.key_image_d_1_th !== "" &&
    banner?.key_image_d_1_th !== null &&
    banner?.key_image_d_1_th !== undefined
  ) {
    image_count_desktop_th++;
  }
  if (
    banner?.key_image_d_2_th !== "" &&
    banner?.key_image_d_2_th !== null &&
    banner?.key_image_d_2_th !== undefined
  ) {
    image_count_desktop_th++;
  }
  if (
    banner?.key_image_d_3_th !== "" &&
    banner?.key_image_d_3_th !== null &&
    banner?.key_image_d_3_th !== undefined
  ) {
    image_count_desktop_th++;
  }

  if (
    banner?.key_image_m_1_th !== "" &&
    banner?.key_image_m_1_th !== null &&
    banner?.key_image_m_1_th !== undefined
  ) {
    image_count_mobile_th++;
  }
  if (
    banner?.key_image_m_2_th !== "" &&
    banner?.key_image_m_2_th !== null &&
    banner?.key_image_m_2_th !== undefined
  ) {
    image_count_mobile_th++;
  }
  if (
    banner?.key_image_m_3_th !== "" &&
    banner?.key_image_m_3_th !== null &&
    banner?.key_image_m_3_th !== undefined
  ) {
    image_count_mobile_th++;
  }

  React.useEffect(() => {
    let thisF = () => {
      if (isMobile && language === "EN") {
        if (image_count_mobile_en > 1) {
          if (count >= image_count_mobile_en) {
            setTimeout(() => {
              setCount(1);
            }, 5000);
          } else {
            setTimeout(() => {
              setCount(count + 1);
            }, 5000);
          }
        }
      } else if (isMobile && language === "TH") {
        if (image_count_mobile_th > 1) {
          if (count >= image_count_mobile_th) {
            setTimeout(() => {
              setCount(1);
            }, 5000);
          } else {
            setTimeout(() => {
              setCount(count + 1);
            }, 5000);
          }
        }
      } else if (!isMobile && language === "EN") {
        if (image_count_desktop_en > 1) {
          if (count >= image_count_desktop_en) {
            setTimeout(() => {
              setCount(1);
            }, 5000);
          } else {
            setTimeout(() => {
              setCount(count + 1);
            }, 5000);
          }
        }
      } else if (!isMobile && language === "TH") {
        if (image_count_desktop_th > 1) {
          if (count >= image_count_desktop_th) {
            setTimeout(() => {
              setCount(1);
            }, 5000);
          } else {
            setTimeout(() => {
              setCount(count + 1);
            }, 5000);
          }
        }
      }
    };

    thisF();

    return () => {
      thisF = () => {};
    };
  }, [
    count,
    image_count_desktop_en,
    image_count_desktop_th,
    image_count_mobile_en,
    image_count_mobile_th,
    size,
    language,
    isMobile,
  ]);

  React.useEffect(() => {
    setCount(1);
  }, [language, isMobile]);

  const isThai = language === "TH";

  if (banner?.status === "Banner") {
    return (
      <div className=" w-full mt-[80px]  md:mt-[72px]  ">
        <img
          onClick={() => {
            if (isThai) {
              onClickTH(banner, count, navigate, isMobile);
            } else {
              onClick(banner, count, navigate, isMobile);
            }
          }}
          loading="lazy"
          src={
            isThai
              ? FunctionGetPathUrl(banner[`key_image_m_${count}_th`])
              : FunctionGetPathUrl(banner[`key_image_m_${count}`])
          }
          className={STYLE_BANNER}
        />
        {/* <LazyLoadImage
          onClick={() => {
            if (isThai) {
              onClickTH(banner, count, navigate, isMobile);
            } else {
              onClick(banner, count, navigate, isMobile);
            }
          }}
          alt={"my-laundry-banner"}
          src={
            isThai
              ? FunctionGetPathUrl(banner[`key_image_m_${count}_th`])
              : FunctionGetPathUrl(banner[`key_image_m_${count}`])
          }
          className={STYLE_BANNER}
        /> */}
      </div>
    );
  } else if (banner?.status === "Video") {
    return (
      <div className=" px-4 md:px-0 w-full">
        <video className={STYLE_BANNER} autoPlay muted loop playsInline>
          <source src={banner?.link} type="video/mp4" />
        </video>
      </div>
    );
  } else if (banner?.status !== "") {
    return "";
  } else {
    return <React.Fragment />;
  }
};

const HomeBanner = React.memo(({ banner }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <RenderHomeBannerMobile banner={banner} />;
  } else {
    return <RenderHomeBanner banner={banner} />;
  }
});
export default HomeBanner;
